import {CommandBase} from '@shared/commands/command-base';
import {Configuration} from '@shared/models/configuration';
export class UpdateReportCommand extends CommandBase {
  reportName: string;
  rateType: string;
  reportId: string;
  dates: Date[];
  reportingCurrencyCodes: string[];
  translationCurrencyCodes: string[];
  reportingCurrencyNames: any;
  translationCurrencyNames: any;
  summaryRateView: string;
  detailRateView: string;
  fxRateFormats: string[];
  constructor() {
    super(Configuration.getConfig('FxRateApi') + `Command/AddFxRateReport`);
    this.reportingCurrencyNames = {};
    this.translationCurrencyNames = {};
  }
}
export class DeleteReportCommand extends CommandBase {
  reportId: string;
  constructor () {
    super(Configuration.getConfig('FxRateApi') + `Command/DeleteFxRateReport`);
  }
}
export class ExportReportCommand extends CommandBase {
  reportId: string;
  constructor () {
    super(Configuration.getConfig('FxRateApi') + `Command/ExportReport`);
  }
}

export class DeleteDynamicFieldCommand extends CommandBase {
  reportId: string;
  sourceType: string;
  constructor () {
    super(Configuration.getConfig('FxRateApi') + `Command/DeleteDynamicFieldCommand`);
  }
}

export class AddFxRateReportDynamicFieldsCommand extends CommandBase {
  reportId: string;
  sourceType: string;
  rateView: string;
  constructor () {
    super(Configuration.getConfig('FxRateApi') + `Command/AddFxRateReportDynamicFields`);
  }
}

export class ChangeSummaryHeaderCommand extends CommandBase {
  sourceType: string;
  rateView: string;
  constructor() {
    super(Configuration.getConfig('FxRateApi') + `Command/ChangeSummaryHeader`);
  }
}

export class CreateReportCommand extends CommandBase {
  reportName: string;
  rateType: string;
  constructor() {
    super(Configuration.getConfig('FxRateApi') + `Command/CreateReport`);
  }
}
